module.exports = __webpack_public_path__ + "img/2.875cea1c.png";